import React from 'react';

const DefaultEmpty: React.FC = () => (
  <div className="flex flex-col items-center justify-center p-8 text-center">
    <div className="text-on-surface/50 text-6xl mb-4">📭</div>
    <h3 className="text-lg font-semibold text-on-surface mb-2">Brak danych</h3>
    <p className="text-on-surface/70">Nie znaleziono żadnych elementów do wyświetlenia.</p>
  </div>
);

export default DefaultEmpty;
